/**
 * BrewNectar Product Lifestyle — fade-up animation
 */
(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initFadeUp(root) {
    var animated = root.querySelectorAll('.bn-plo__animate');

    if (
      prefersReducedMotion() ||
      !('IntersectionObserver' in window) ||
      (typeof Shopify !== 'undefined' && Shopify.designMode)
    ) {
      animated.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var rootMargin = root.getAttribute('data-bn-plo-observer-margin') || '-60px 0px';
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: rootMargin, threshold: 0 }
    );

    animated.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.bnPloInit === 'true') return;
    root.dataset.bnPloInit = 'true';

    if (root.classList.contains('bn-plo--static')) {
      root.querySelectorAll('.bn-plo__animate').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    initFadeUp(root);
  }

  function initAll() {
    document.querySelectorAll('.bn-plo').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.bn-plo');
    if (root) {
      delete root.dataset.bnPloInit;
      initRoot(root);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('.bn-plo');
    if (root) delete root.dataset.bnPloInit;
  });
})();
